// CSS Style
import 'styles/client/vendors/animate.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'styles/songsongmeow';

// Other JS
import 'core-js';
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import Rails from "@rails/ujs"
Rails.start();

// 因為在 webpack 打包的時候，沒有瀏覽器的 window 物件，所以必須 assign 這樣才能在 rails view 使用
// Ref: https://tinyurl.com/ycrtavmd
window.jQuery = $;
window.$ = $;
window.Swal = Swal;

$(document).ready(function () {
  $('#btn_start').on('click', function () {
    $('.frame[data-step]').attr('data-step', 'contentQ1');
  });
  $('[data-next]').on('click', function () {
    var ans = $(this).data('ans');
    var respond = $(this).data('respond');
    var next_page = $(this).data('next');
    if (ans == "a") {
      Swal.fire({
        html: "<div class='respond-content'>" + respond + "</div>",
        confirmButtonText: "NEXT",
        customClass: {
          container: "respond-container",
          popup: 'respond-popup respond-popup-a',
          confirmButton: 'btn-next'
        }
      }).then(function (result) {
        $('.frame[data-step]').attr('data-step', "content" + next_page);
      });
    } else {
      Swal.fire({
        html: "<div class='respond-content'>" + respond + "</div>",
        confirmButtonText: "NEXT",
        customClass: {
          container: "respond-container",
          popup: 'respond-popup respond-popup-b',
          confirmButton: 'btn-next'
        }
      }).then(function (result) {
        $('.frame[data-step]').attr('data-step', "content" + next_page);
      });
    }
  });
});
